module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("item " + (_vm.isLast ? 'is-last' : '') + " " + (_vm.open ? 'open' : ''))
  }, [_c('div', {
    staticClass: "title",
    on: {
      "click": _vm.updateActiveId
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_c('span', {
    staticClass: "fugaz-one-style"
  }, [_vm._v("Q:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('span', {
    staticClass: "open-icon icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.openIcon,
      "alt": "icon"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "close-icon icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.closeIcon,
      "alt": "icon"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toggle-box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "fugaz-one-style"
  }, [_vm._v("A:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.content))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-28a09938"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sectionQuestion/Item.vue
// module id = 669
// module chunks = 0